<template>
<div>
  <my-header></my-header>

  <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <router-view></router-view>
      </div>
    </div>
</div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'Pushes',

  components: {
    MyHeader,
    SideNav,
  },

  data() {
    return {
      isLoading: false,
      pushes: null,

      updateTimeoutId: null,

      /** @type {?AbortController} */
      loadingAbortController: null,
    };
  },

  computed: {
    menuItems() {
      return [
        {
          title: 'User pushes',
          route: {name: 'pushes_user'},
        },
        {
          title: 'User push log',
          route: {name: 'pushes_user_log'},
        },
        {
          title: 'Auto pushes',
          route: {name: 'pushes_auto'},
        },
      ];
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  min-width: 600px;
  max-width: 600px;
  padding-top: 1em;
}
</style>